/**
 * PC 伴学助手（header-box 等）中英文文案
 */
export const aiStudyBuddyZh = {
  aiStudyBuddy: {
    title: 'AI 伴学助手',
    sidebarNewChat: '开启新对话',
    sidebarRecommend: '帮我推荐活动',
    sidebarTopic: 'AI生成选题',
    sidebarHistory: '历史对话',
    compactGreet: 'Hi~挑战太多？让AI帮你找到最适合的赛场！',
    newChatGreet: 'Hi~我是你的AI伴学助手，可以为你答疑解惑，伴你成长。',
    greetBloomShort: 'Hi～我是布隆，你的AI伴学助手，可以为你答疑解惑，伴你成长。',
    recommendIntro: 'Hi～我是布隆，你的AI伴学助手，接下来我将根据你感兴趣的学科、研究方向、年级等信息，帮你推荐活动。',
    recommendQuestion: '请问你感兴趣的学科或研究方向有哪些？例如：经济学、生物学、化学、文学、艺术学、新媒体传播等，可以有多个。',
    topicIntro: 'Hi～我是布隆，你的AI伴学助手，可以为你答疑解惑，伴你成长。',
    topicQuestion: '请问你研究方向的关键词有哪些？可结合学科、领域、场景等维度告诉我关键词，2-5个关键词为佳。',
    cardRecommendTitle: '帮我推荐活动',
    cardRecommendDesc: '根据你感兴趣的学科、研究方向、年级等信息，帮你推荐活动',
    cardTopicTitle: 'AI生成选题',
    cardTopicDesc: '通过学科、研究方向、场景等关键词，帮你生成参考选题，辅助你理清选题思路',
    challengesLead: '根据你的需求，为你推荐以下挑战：',
    topicIdeasLead: '根据你的需求，为你联想以下课题：',
    cardActivityName: '活动名称：',
    cardRegistrationPeriod: '报名时间：',
    cardEligibility: '报名条件：',
    cardRecommendationLevel: '推荐指数：',
    cardWhyRecommended: '推荐理由：',
    viewActivityDetails: '查看活动详情 »',
    placeholderInput: '请输入...',
    knowledgePlaceholder: '请输入你的知识疑问，让我为你答疑解惑。',
    disclaimer: '内容由AI生成，仅供参考。',
    historyEmpty: '暂无历史记录。在「开启新对话」中发送消息后，记录将显示在左侧「历史对话」下方。',
    historySelectHint: '在左侧选择一条历史记录查看对话。',
    localHistoryPlaceholder: '已收到您的问题，完整 AI 回复可在接口对接后在此展示。',
    ariaCloseMenu: '关闭菜单',
    ariaOpenMenu: '打开菜单',
    ariaClose: '关闭',
    ariaSend: '发送',
    /** 等待 IM 流式/complete 期间发送钮为生成中图标 */
    ariaSendWaiting: '回复生成中',
    ariaExpandFull: '展开全屏',
    ariaShrinkWindow: '缩小窗口',
    ratingAria: '评分 {rating} / 5',
    badgeOpen: '报名中',
    badgeEnded: '已结束',
    badgePending: '未开始',
    /** 等待首条 IM 回复：与动态省略号拼接，不含省略号 */
    thinkingBase: 'AI伴学助手思考中',
    thinking: 'AI伴学助手思考中……',
    /** IM750 messageData.kind=error 且未下发 errMessage 时的兜底 */
    im750ErrorFallback: '服务暂时不可用，请稍后重试。',
    /** IM 敏感/内容安全类错误且未下发具体 errMessage 时的兜底提示（不展示用户原文） */
    im750SensitiveTipFallback: '您发送的内容包含敏感信息，无法继续回答，请修改后重试。',
    im750TimeoutTip: '回复可能因网络未完全送达，已结束等待。若内容不完整请重试。',
    /** 用户停止生成且尚未收到任何 IM 正文时 */
    userStoppedNoContentTip: '您已停止生成，暂未收到回复。',
    /** 等待 IM 时发送钮可点停止：无障碍文案 */
    ariaStopGeneration: '停止生成',
    collapse: '收起',
    expand: '展开',
    placeholderAsk: '有问题尽管问',
    placeholderRecommend: '帮我推荐活动',
    placeholderTopic: '帮我生成选题'
  }
}

export const aiStudyBuddyEn = {
  aiStudyBuddy: {
    title: 'AI Study Buddy',
    sidebarNewChat: 'New Chat',
    sidebarRecommend: 'Help Me Find Activities',
    sidebarTopic: 'AI‑Generated Topics',
    sidebarHistory: 'Conversation History',
    compactGreet: 'Too many challenges? Let AI help you find the best fit!',
    newChatGreet: "Hi~ I'm your AI Study Buddy. I'm here to answer your questions and support your growth.",
    greetBloomShort: "Hi~ I'm Bloom, your AI Study Buddy. I'm here to answer your questions and support your growth.",
    recommendIntro:
      "Hi~ I'm Bloom, your AI Study Buddy. I can recommend activities based on your interests, research fields, grade level, and other information.",
    recommendQuestion:
      'What subjects or research fields are you interested in? (e.g., Economics, Biology, Chemistry, Literature, Art, New Media Communication, etc. You can list multiple.)',
    topicIntro: "Hi~ I'm Bloom, your AI Study Buddy. I'm here to answer your questions and support your growth.",
    topicQuestion:
      'What keywords describe your research direction? Tell me 2–5 keywords across subject, field, or scenario.',
    cardRecommendTitle: 'Help Me Find Activities',
    cardRecommendDesc: 'I can recommend activities based on your interests, research fields, grade level, and other information.',
    cardTopicTitle: 'AI‑Generated Topics',
    cardTopicDesc:
      'I can generate topic ideas based on keywords like subject, research field, or scenario to help you clarify your direction.',
    challengesLead: 'Based on your needs, here are some challenges for you:',
    topicIdeasLead: 'Based on your needs, here are some related project ideas:',
    cardActivityName: 'Activity Name:',
    cardRegistrationPeriod: 'Registration Period:',
    cardEligibility: 'Eligibility:',
    cardRecommendationLevel: 'Recommendation Level:',
    cardWhyRecommended: "Why it's recommended:",
    viewActivityDetails: 'View Activity Details »',
    placeholderInput: 'Type here…',
    knowledgePlaceholder: "Please enter your question about a knowledge point, and I'll help explain it.",
    disclaimer: "AI-generated content. Reference only.",
    historyEmpty:
      'No history yet. Send a message in New Chat and it will appear below Conversation History on the left.',
    historySelectHint: 'Select a conversation on the left to view it.',
    localHistoryPlaceholder: 'We received your message. Full AI replies will appear here once integrated.',
    ariaCloseMenu: 'Close menu',
    ariaOpenMenu: 'Open menu',
    ariaClose: 'Close',
    ariaSend: 'Send',
    ariaSendWaiting: 'Generating reply',
    ariaExpandFull: 'Expand to full screen',
    ariaShrinkWindow: 'Shrink window',
    ratingAria: 'Rating {rating} out of 5',
    badgeOpen: 'Enrolling',
    badgeEnded: 'Ended',
    badgePending: 'Not started',
    thinkingBase: 'AI Study Buddy is thinking',
    thinking: 'AI Study Buddy is thinking…',
    im750ErrorFallback: 'Something went wrong. Please try again later.',
    im750SensitiveTipFallback:
      'Your message contains sensitive content and cannot be processed. Please revise and try again.',
    im750TimeoutTip:
      'The reply may be incomplete due to a network issue. Waiting has ended; try again if needed.',
    userStoppedNoContentTip: 'You stopped generation. No reply has arrived yet.',
    ariaStopGeneration: 'Stop generation',
    collapse: 'Collapse',
    expand: 'Expand',
    placeholderAsk: 'Ask me anything',
    placeholderRecommend: 'Help Me Find Activities',
    placeholderTopic: 'Help with topic ideas'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/aiStudyBuddy/index.js